export default "__VITE_ASSET__MUqHvVv___"